import { render } from "./BadgesContent.vue?vue&type=template&id=20b4fc55"
import script from "./BadgesContent.vue?vue&type=script&lang=js"
export * from "./BadgesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__